<template>

  <div class="columns">
    <div class="column">
      <div class="card">

        <http-messages :success="success" :errors="errors" :message="response"></http-messages>

          <div class="card-content">

            <div class="field">
              <label for="name">Naam</label>
              <div class="control">
                <input type="text" name="name" v-model="name" class="input">
              </div>
              <p v-for="message in errors.name" class="help is-danger">{{ message }}</p>
            </div>

            <div class="field">
              <label for="email">E-mail</label>
              <div class="control">
                <input type="text" name="email" v-model="email" class="input">
              </div>
              <p v-for="message in errors.email" class="help is-danger">{{ message }}</p>
            </div>

            <div class="field">
              <label for="message">Bericht</label>
              <div class="control">
                <textarea name="message" class="textarea" v-model="message"></textarea>
              </div>
              <p v-for="message in errors.message" class="help is-danger">{{ message }}</p>
            </div>

            <div class="field">
              <div class="control">
                <button
                  type="button"
                  class="button"
                  :disabled="!valid"
                  @click="send">Verzenden</button>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

</template>


<script>
import axios from 'axios'
import HttpMessages from '@/components/http/HttpMessages'

export default {
  components: {
    HttpMessages
  },
  data () {
    return {
      name: null,
      email: null,
      message: null,
      loading: null,
      success: null,
      errors: {},
      response: null
    }
  },
  computed: {
    valid () {
      if (this.name && this.email && this.message) {
        return this.validateEmail(this.email)
      }

      return false
    }
  },
  methods: {
    validateEmail (email) {
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(String(email).toLowerCase());
    },
    send () {
      this.success = false
      this.loading = true
      this.errors = {}

      axios.post(
        `/contact`, {
          name: this.name,
          email: this.email,
          message: this.message
        }
      ).then(
        (res) => {
          this.loading = false
          this.success = true
          this.response = 'Uw bericht is verzonden'
          this.name = this.email = this.message = null
        }
      ).catch(
        (err) => {
          this.errors = error.response.data.errors
          this.success = false
        }
      )
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contact/ContactForm.vue